export interface FilterParams {
    page: number;
    size: number;
    sort: string;
    dir: string;
}